// 3rd-party modules
import { v4 as uuidv4 } from "uuid";
import { customTags } from "../plugins/ignoreElements";
const _sanitizeHtml = require('sanitize-html');

export const trimStringProps = (object: any) => {
  for (let prop of Object.keys(object)) {
    if (typeof object[prop] === 'string')
      object[prop as keyof object] = (object[prop as keyof object] as String).trim();
  }

  return object;
}

export const generateKey = () => {
  return uuidv4();
};


/**
 *
 * @param object
 * @param includes : array, Use if you need to convert only a list of keys to snakecase. In case of seting both arrays, this one is prioritize.
 * @param excludes : array, Use if you need to convert all keys but these to snakecase. In case of seting both arrays, Include logic is prioritize.
 * @returns
 */
export const convertToSnakecase = (object: any, includes: any[] = [], excludes: any[] = []) => {
  for (let prop of Object.keys(object)) {
    if ((includes.length && includes.includes(prop)) || (!includes.length && !excludes.includes(prop))) {
      const newKey = prop.replace(/\.?([A-Z]+)/g, function (x,y){return "_" + y.toLowerCase()}).replace(/^_/, "");
      if (newKey !== prop) {
        object[newKey as keyof object] = object[prop as keyof object];
        delete object[prop as keyof object];
      }
    }
  }
  return object;
};

export const objectToFormData = (obj: any) => {
  const formData = new FormData();

  // Iterate over each key-value pair in the object
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      // If the value is an array, append each element separately
      if (Array.isArray(value)) {
        value.forEach((element) => {
          formData.append(key, element);
        });
      } else {
        // Otherwise, append the value directly
        formData.append(key, value);
      }
    }
  }

  return formData;
}

export const sanitizeHtml = (html: string) => {
  const options = {
    allowedTags: [
      "h1", "h2", "h3", "h4", "h5", "h6", "div", "ol", "p", "pre", "ul", "a", "b", "br", "em", "i", "small", "span", "strong", "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "img",
      ...Array.from(customTags)
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
      a: [ 'href', 'name', 'target' ],
      img: ['src']
    },
    selfClosing: [ 'img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta' ],
    allowedSchemes: [ 'http', 'https', 'ftp', 'mailto', 'tel', 'data' ],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: [ 'href', 'src' ],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false
  };

  return _sanitizeHtml(html, options);
};

export const capitalizeFirstLetter = (input: string) => {
  return input.charAt(0).toUpperCase() + input.slice(1);
}

export const formatMoney = (amount: number, decimalCount = 0, decimal = '.', thousands = ',') => {
  if (amount === null)
    return "0";

  decimalCount = Math.abs(decimalCount)
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount

  const negativeSign = amount < 0 ? '-' : ''
  const i = parseInt(Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
  const j = (i.length > 3) ? i.length % 3 : 0

  return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - Number(i)).toFixed(decimalCount).slice(2) : '');
}

export const toKababCase = (input: string) => {
  return input.replace(/([a-z0–9])([A-Z])/g, "$1-$2").toLowerCase();
}

export const kababCaseToCamelCase = (input: string) => {
  return input.replace(/-./g, x=>x[1].toUpperCase());
}

export const getStringFirstLetters = (input: string): string => {
  if (!input) {
    return "";
  }

  const parts = input.split(" ");
  let returnVal = "";

  if (parts.length > 1) {
    if (parts[0][0]) {
      returnVal += parts[0][0].toUpperCase();
    }
    if (parts[1][0]) {
      returnVal += parts[1][0].toUpperCase();
    }
  } else if (parts.length === 1) {
    if (parts[0][0]) {
      returnVal += parts[0][0].toUpperCase();
    }
    if (parts[0][1]) {
      returnVal += parts[0][1].toUpperCase();
    }
  }

  return returnVal;
}

export const b64toBlob = (b64Data: string, contentType: string ='', sliceSize: number = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

/*
export const mobileCheck = () => {
  let check = false;

  //@ts-ignore
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
};
*/
